import { ConfigProvider, DatePicker, Form } from "antd";

import localeEn from 'antd/es/date-picker/locale/en_US';
import localeTh from 'antd/es/date-picker/locale/th_TH';
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import "./DatePickerModule.css";
import styles from "./Input.module.css";

const FormDatePicker = ({
    label = "",
    name = "",
    value = null,
    placeholder = null,
    type = "text",
    size = "middle",
    defaultValue = null,
    onChange = () => { },
    className = "",
    subclassName = "",
    required = false,
    options = [],
    vertical = true,
    disabled = false,
    dateFormat: format = "DD/MM/YYYY",
    labelFontSize = "14px",
    fontWeight = "",
    minDate = null,
    maxDate = null,
    disabledDate = () => { },
    picker = "date",
    style = {},
    rules = null,
    allowClear = false
}) => {

    const handleChange = (e) => {
        console.log("handleChange", e);
        const value = e;
        onChange(value);
    };

    const { i18n } = useTranslation();

    const layout = {
        labelCol: {
            span: 24,
        },
        wrapperCol: {
            span: 24,
        }
    }


    const { RangePicker } = DatePicker;


    // console.log("locale", locale);

    function localeFn() {
        if (i18n.language === 'en') {
            return localeEn
        } else {
            return {
                ...localeTh,
                lang: {
                    ...localeTh.lang,
                    yearFormat: "BBBB",
                    dateFormat: "D/M/BBBB",
                    cellYearFormat: "BBBB"
                }
            }
        }
    }

    return (
        <ConfigProvider theme={{
            components: {
                Form: {
                    labelFontSize: labelFontSize
                },
            },
        }}>
            <Form.Item
                style={{
                    padding: "0px",
                    margin: "0px !important"
                }} shouldUpdate={() => false}>
                {(form) => (<Form.Item
                    {...(vertical && layout)}
                    className={styles.datePicker}
                    labelAlign="left"
                    label={label}
                    name={name}
                    required={required}
                    style={{
                        fontWeight: fontWeight,
                        padding: "0px",
                        margin: "0px !important"
                    }}
                    rules={(rules || []).concat({
                        required,
                        message: `${i18n.language === 'th' ? 'กรุณากรอก' : 'is required'} ${label}`
                    })}
                >
                    {type === "range" ? (
                        <RangePicker
                            style={{
                                width: "100%",
                                ...style
                            }}
                            styles={{
                                popup: {
                                    width: "10vw"
                                }
                            }}
                            className={styles.datePicker}
                            locale={localeFn()}
                            id={name}
                            name={name}
                            placeholder={placeholder ?? label}
                            type={type}
                            minDate={minDate}
                            maxDate={maxDate}
                            // onBlur={(e, info) => {
                            //     console.log("e.target.value", e.target.value);
                            //     if (e.target.value) {
                            //         if (i18n.language == 'en') {
                            //             // return e.target.value

                            //             if (dayjs(e.target.value, format)?.$d == 'Invalid Date') {
                            //                 form.setFieldValue([name], null)
                            //             } else {
                            //                 form.setFieldValue([name], (dayjs(e.target.value, format)))
                            //                 onChange(dayjs(e.target.value, format), info)

                            //             }
                            //         } else if (i18n.language == 'th') {
                            //             if (dayjs(e.target.value, format).add(-543, 'year')?.$d == 'Invalid Date') {

                            //                 form.setFieldValue([name], null)
                            //             } else {
                            //                 form.setFieldValue([name], (dayjs(e.target.value, format).add(-543, 'year')))

                            //             }
                            //             if (dayjs(e.target.value, format).isValid()) {
                            //                 onChange(dayjs(e.target.value, format).add(-543, 'year'), info)
                            //             }
                            //         }

                            //     }
                            // }}
                            onChange={onChange}
                            defaultValue={defaultValue}
                            // onOk={handleChange}
                            format={i18n.language === 'en' ? format : format.replace(/(Y)/g, "B")}
                            disabled={disabled}
                            size={size}
                            allowClear={allowClear}
                            // getPopupContainer={(trigger) => {
                            //     return trigger.parentNode
                            // }}
                            disabledDate={disabledDate}
                        />
                    ) : (
                        <DatePicker
                            style={{
                                width: "100%",
                                ...style
                            }}
                            popupClassName="custom-datepicker-panel"
                            // className={styles.datePickerCustom}
                            className={styles.datePicker}
                            locale={localeFn()}
                            id={name}
                            name={name}
                            placeholder={placeholder ?? label}
                            defaultValue={defaultValue}
                            type={type}
                            minDate={minDate}
                            maxDate={maxDate}
                            // onOk={() => {
                            //     console.log("onChange onChangeonChange ");
                            // }}
                            // onChange={onChange}
                            // onChange={handleChange}

                            onBlur={(e, info) => {
                                if (picker === "date") {
                                    if (e.target.value) {
                                        if (i18n.language === 'en') {
                                            // return e.target.value
                                            if (dayjs(e.target.value, format)?.$d === 'Invalid Date') {
                                                e.preventDefault()
                                                // form.setFieldValue([name], null)
                                            } else {
                                                form.setFieldValue([name], (dayjs(e.target.value, format)))
                                                if (dayjs(e.target.value, format).isValid()) {
                                                    onChange(dayjs(e.target.value, format), info)
                                                }
                                            }
                                        } else if (i18n.language === 'th') {
                                            if (dayjs(e.target.value, format).add(-543, 'year')?.$d === 'Invalid Date') {
                                                e.preventDefault()
                                                // form.setFieldValue([name], null)
                                            } else {
                                                form.setFieldValue([name], (dayjs(e.target.value, format).add(-543, 'year')))
                                                if (dayjs(e.target.value, format).isValid()) {
                                                    onChange(dayjs(e.target.value, format).add(-543, 'year'), info)
                                                }
                                            }
                                        }
                                    }
                                }

                                // e.preventDefault()
                                // form.setFieldValue([name], dayjs())
                            }}
                            format={i18n.language === 'en' ? format : format.replace(/(Y)/g, "B")}
                            disabled={disabled}
                            size={size}
                            getPopupContainer={(trigger) => {
                                return trigger.parentNode
                            }}
                            allowClear={allowClear}
                            disabledDate={disabledDate}
                            picker={picker}
                            onChange={(date, dateString) => {
                                onChange(date, dateString);
                            }}
                        />
                    )}
                </Form.Item>)
                }
            </Form.Item>
        </ConfigProvider>
    );
};

export default FormDatePicker;
